import React from 'react';
import { connect } from 'react-redux';
import { LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts';

const Chart = ({ chartData }) => {
  return chartData.length === 0 ? (
    <div></div>
  ) : (
    <div className="chart">
      <LineChart
        width={1000}
        height={500}
        data={chartData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <XAxis dataKey="name" stroke="black" />
        <YAxis stroke="black" />
        <Tooltip />

        <Line
          type="monotone"
          dataKey="price"
          stroke="#000"
          activeDot={{ r: 8 }}
        />
      </LineChart>
    </div>
  );
};

const mapState = (state) => ({
  chartData: state.stocks.chartData,
});

export default connect(mapState, null)(Chart);
